export const environment = {
  production: false,
  BACK_URL: 'https://dev.mykoolcat.com',
  STRIPE_BACK_URL: 'https://dev.mykoolcat.com',
  STRIPE_CLIENT_ID: '',
  STRIPE_KEY: 'pk_test_51Ty73cK3GSvG2TZe7XxbrMeOmAibC2TQ2H06iqjgrKxjVjZmxO5tcI4FsQdiTxTQ6JUEvHd4DIMUyvnzPSn72Ge900fcK0wwT3',
  STRIPE_CONNECT_OAUTH_CLIENT_ID: 'ca_Uy3FfHElHfmyAtfpb7Cx3E3JUXjPRXhm',
  STRIPE_CONNECT_KEY: 'pk_test_51Ty73cK3GSvG2TZe7XxbrMeOmAibC2TQ2H06iqjgrKxjVjZmxO5tcI4FsQdiTxTQ6JUEvHd4DIMUyvnzPSn72Ge900fcK0wwT3',
  GOOGLE_MAPS_BROWSER_KEY: 'AIzaSyCtM0KT9GetuT_x1GrKuy9JSn1gTf81erY'
};
